module.exports = __webpack_public_path__ + "img/seek_advice.af15a8a0.png";